'use client'
import React from 'react'
import { Accordion, AccordionItem } from '@nextui-org/react'
import { MdLocalShipping, MdWorkspacePremium, MdMoney } from 'react-icons/md'

const DetailsAccordian = () => {
    const details = [
        {
            icon: < MdLocalShipping />,
            title: "Shipping & Return Policy",
            content: "We ship your Chai from our warehouse in the USA. It takes 1-2 business day&#40;s&#41; to process orders before they are shipped. Once your item&#40;s&#41; have been dispatched&#44; the tracking link will be shared.  <br/> <br/>Discover the excellence of Chaivio teas&#44; and rest assured that our customer-friendly return policy will simplify the process for you if needed. Explore further details by  <a target='_blank' href='/return-policy' style='color:orange;'>Clicking here</a>."

        },
        {
            icon: < MdWorkspacePremium />,
            title: "* Legal Disclaimer",
            content: "Statements regarding dietary supplements have not been evaluated by the FDA & are not intended to diagnose, treat, cure, or prevent any disease or health condition.Users are urged to consult with a healthcare professional for advice. Additionally&#44; Chaivio disclaims responsibility for any consequences resulting from reliance on this information."
        },
        // {
        //     icon: < MdMoney />,
        //     title: "Return Policy",
        //     content: "We love our Chaivio teas and we're confident you will too. In case things don't go as planned, our return policy is designed to make things as easy as possible for you. <a target='_blank' href='/return-policy' style='color:orange;'>Click here</a> to learn more about how we can help."

        // }

    ]
    return (
        <Accordion variant='bordered' className='w-full'>
            {
                details.map((item, index) => {
                    return (
                        <AccordionItem key={index} title={item.title} startContent={item.icon}>
                            <p dangerouslySetInnerHTML={{ __html: item.content }}></p>
                        </AccordionItem>

                    )
                })
            }
        </Accordion>
    )
}

export default DetailsAccordian